import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Errors } from '../layout/Errors';
import { Row, Col, Button } from 'reactstrap';
import { Routes } from '../../config';
import { isAuthenticated } from '../../api/helper';
import './NotFound.scss';

const  NotFound =()=> {
  
    return (
      <div className="not-found-page">
        <Errors title={<FormattedMessage id="app.errors.NotFound.page_title" />} >
          <div className="not-found-page__content">
            { <FormattedMessage id="app.errors.NotFound.content" /> }
          </div>
          <Row className="not-found-page__actions text-center">
            <Col>
              {isAuthenticated() &&
              <Button className="not-found-page__action" color="link" href={Routes.ROUTE_DASHBOARD}>
                <FormattedMessage id="navigation.dashboard"/>
              </Button>}
              {! isAuthenticated() &&
              <Button className="not-found-page__action" color="link" href={Routes.ROUTE_HOME}>
                <FormattedMessage id="navigation.home"/>
              </Button>}
            </Col>
            {! isAuthenticated() && <Col>

              <Button className="not-found-page__action" color="link" href={Routes.ROUTE_LOGIN}>
                <FormattedMessage id="components.pages.static.header.login"/>
              </Button>
            </Col>
            }
          </Row>
        </Errors>
      </div>
    );
}

export { NotFound };
